export default class ResetController {
  constructor($scope, $rootScope, $routeParams, $location, $window, User,
    AnalyticsServ) {
    this.location = $location;
    this.window = $window;
    this.analyticsServ = AnalyticsServ;
    this.user = new User({
      token: $routeParams.token,
      welcome: $location.path() === '/welcome',
      password: null
    });
    this.clioAuthFlow = $location.search()['authenticate-clio']
    this.redirect = $routeParams.path || '/home';
    document.querySelector('[name="password"]').focus();

  }
  openClioAuth(e) {
    e.stopPropagation();
    e.preventDefault();
    var clioId = window.conf.clio;
    var redirectUri = window.conf.clioUri;
    this.window.open(
      "https://app.goclio.com/oauth/authorize?response_type=code&state=" +
      this.user.data.id + "&client_id=" + clioId +
      "&redirect_uri=" + redirectUri + this.user.data.id,
      '_blank',
      'height=700,width=525,status=no,scrollbars=no, resizable=yes');
  }
  setPassword() {
    this.user.api.initPassword().then(data => {
      this.analyticsServ.signedUp(data, true)
      if (this.clioAuthFlow) {
        this.showClioAuthStep = true;
      } else {
        this.location.url(this.redirect);
      }
    });
  }
  resetPassword() {
    this.user.api.resetPassword().then(() => {
      this.analyticsServ.analytics.track('Password Reset')
      this.location.url(this.redirect);
    });
  }
}
ResetController.$inject = ['$scope', '$rootScope', '$routeParams', '$location',
  '$window', 'User', 'AnalyticsServ'
]



// WEBPACK FOOTER //
// ./project/pages/reset/reset.controller.js